<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Informations du groupe</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Code</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="10"
              [(ngModel)]="groupe.groupe_Code"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Libellé</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="groupe.groupe_Libelle"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
